import { GatewayQuestionnaire } from "@conformite/gateway";
import { TagVariant } from "@endya-conformite/ui-kit";

type OptionColor = GatewayQuestionnaire.OptionColor;
type QuestionOption = GatewayQuestionnaire.QuestionOption;

const OPTION_COLOR_TO_TAG_VARIANT: Record<OptionColor, TagVariant> = {
  green: "success",
  red: "error",
  blue: "info",
  orange: "warning",
};

export function getSuggestedOptionColor(
  answer: string,
  options: QuestionOption[],
  colorOverrides?: Record<string, OptionColor>
): OptionColor | undefined {
  const option = options.find((o) => o.label === answer);
  if (!option) return undefined;
  return colorOverrides?.[option.id] ?? option.color;
}

export function getSuggestedTagVariant(
  answer: string,
  options: QuestionOption[],
  colorOverrides?: Record<string, OptionColor>
): TagVariant | undefined {
  const color = getSuggestedOptionColor(answer, options, colorOverrides);
  return color ? OPTION_COLOR_TO_TAG_VARIANT[color] : undefined;
}
